import axios from 'axios';

import c from '../helpers/constants';

export function getFieldTypes() {
  return (
    axios({
      url: c.API_ENDPOINTS.FIELD_TYPES,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
